"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _SVGBase = _interopRequireDefault(require("./SVGBase"));

var _Constants = require("../../Constants");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-size: cover;\n  background-position: center;\n  display: block;\n  fill: ", ";\n  font-family: 'Avenir Next W02', Helvetica, Arial, sans-serif;\n  font-size: ", "%;\n  text-anchor: middle;\n  width: 100%;\n  height: ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents.default)(_SVGBase.default).withConfig({
  displayName: "SVGWrapper",
  componentId: "ehtitt-0"
})(_templateObject(), function (props) {
  return props._isHasMore ? _colors.OBSIDIAN : 'currentColor';
}, function (props) {
  return props._isHasMore ? '340' : '290';
}, function (props) {
  return props.size && props.size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[props.size] + "px" : 'inherit';
}, function (props) {
  return props.src ? "background-image: url('" + props.src + "');" : "background-color: " + (props._isHasMore ? _colors.OLAF : _colors.EERIE) + ";";
}, function (props) {
  return /hubfs\/defaults\/company\.png/.test(props.src) && props._isReversed && 'background-position: -2px;';
});

exports.default = _default;
module.exports = exports.default;